// extracted by mini-css-extract-plugin
export default {"options":"ztK5LIYf7wd4gAT5mZBM","mainTooltip":"OPpodAngP9M8X_0VYdoZ","fixed":"NH4LVIyG1YdwVwCmGoAZ","customerEnters":"o0sZS7zjhQt3gGi1W9Lw","customerCanEdit":"Gh9neEp73E2iaJ2CPv_A"};